module.exports = __webpack_public_path__ + "img/open-indicator.dd9183d4.svg";